var _BreadcrumbDivider;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { forwardRef } from 'react';
import { any, array, bool } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import SovosLink from "../../sovos-link/SovosLink";
var BreadcrumbList = styled('ol')({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  whiteSpace: 'nowrap'
});
var Breadcrumb = styled('li')(function (_ref) {
  var _ref$theme = _ref.theme,
    palette = _ref$theme.palette,
    typography = _ref$theme.typography;
  return _objectSpread(_objectSpread({}, typography.body1), {}, {
    color: palette.text.secondary,
    margin: 0,
    padding: 0,
    display: 'inline'
  });
});
var BreadcrumbText = styled(SovosLink)(function (_ref2) {
  var _ref2$theme = _ref2.theme,
    palette = _ref2$theme.palette,
    transitions = _ref2$theme.transitions;
  return {
    color: palette.text.secondary,
    transition: "color ".concat(transitions.duration.complex, "ms"),
    outline: 'none',
    '&.sovosPageTitleBar__breadCrumbText--clickable': {
      '&:hover': {
        cursor: 'pointer',
        color: palette.text.primary,
        textDecoration: 'underline'
      }
    }
  };
});
var BreadcrumbDivider = styled('span')(function (_ref3) {
  var spacing = _ref3.theme.spacing;
  return {
    padding: "0 ".concat(spacing(0.75))
  };
});
export var abbreviatedText = '…';
export var BreadcrumbsWithoutRef = function BreadcrumbsWithoutRef(_ref4) {
  var ancestorsCollapsed = _ref4.ancestorsCollapsed,
    forwardedRef = _ref4.forwardedRef,
    pageCrumbs = _ref4.pageCrumbs,
    parentCollapsed = _ref4.parentCollapsed;
  var renderBreadcrumb = function renderBreadcrumb(item, isCollapsed) {
    return /*#__PURE__*/React.createElement(BreadcrumbText, {
      onClick: item.onClick,
      className: clsx('sovosPageTitleBar__breadCrumbText', !!item.onClick && 'sovosPageTitleBar__breadCrumbText--clickable'),
      tabIndex: 0,
      role: "button",
      title: isCollapsed && item.text
    }, isCollapsed ? abbreviatedText : item.text);
  };
  return /*#__PURE__*/React.createElement("nav", {
    ref: forwardedRef,
    className: "sovosPageTitleBar__breadcrumbsContainer",
    "aria-label": "breadcrumb"
  }, /*#__PURE__*/React.createElement(BreadcrumbList, null, pageCrumbs === null || pageCrumbs === void 0 ? void 0 : pageCrumbs.map(function (element, index) {
    var isLastItem = index === pageCrumbs.length - 1;
    var isCollapsed = parentCollapsed || !isLastItem && ancestorsCollapsed;
    return /*#__PURE__*/React.createElement(Breadcrumb, {
      className: "sovosPageTitleBar__breadCrumb",
      key: "BreadCrumb-".concat(element.text)
    }, renderBreadcrumb(element, isCollapsed), !isLastItem && (_BreadcrumbDivider || (_BreadcrumbDivider = /*#__PURE__*/React.createElement(BreadcrumbDivider, {
      "aria-hidden": "true"
    }, "/"))));
  })));
};
BreadcrumbsWithoutRef.propTypes = {
  ancestorsCollapsed: bool.isRequired,
  forwardedRef: any.isRequired,
  pageCrumbs: array.isRequired,
  parentCollapsed: bool.isRequired
};
export default /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(BreadcrumbsWithoutRef, _extends({}, props, {
    forwardedRef: ref
  }));
});